import { Grid, Typography } from '@material-ui/core';
import { formatMoney, Money } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';
import { useScreen } from '@/hooks/useScreen';

interface PayoutSummaryConditionsRowProps {
  labelTid: string;
  amount: Money;
  quantity?: number;
  strongLabel?: boolean;
  strongValue?: boolean;
  labelDynamicDataTexts?: string[];
}

export function PayoutSummaryConditionsRow({
  labelTid,
  quantity,
  amount,
  strongLabel = false,
  strongValue = false,
  labelDynamicDataTexts,
}: PayoutSummaryConditionsRowProps) {
  const { isMobile } = useScreen();

  return (
    <Grid container className={isMobile ? 'mt-2 mb-1' : 'my-2'}>
      <Grid item xs={6}>
        <Typography variant={'body2'} color="textPrimary" align={'left'} className="overflow-text-ellipsis">
          <Text strong={strongLabel} tId={labelTid} dynamicDataTexts={labelDynamicDataTexts} />
        </Typography>
      </Grid>
      <Grid item xs={3}>
        {quantity && !isMobile ? (
          <Typography variant={'body2'} color="textPrimary" align={'right'}>
            {quantity}
          </Typography>
        ) : null}
      </Grid>
      <Grid item xs={3}>
        <Typography variant={'body2'} color="textPrimary" align={'right'}>
          {strongValue ? <strong>{formatMoney(amount, 2)}</strong> : formatMoney(amount, 2)}
        </Typography>
      </Grid>
    </Grid>
  );
}
